import { ListingsSearchAllFilters, ListingsSearchBarFilters } from '../types';

export function mapListingsSearchAllFiltersToBarFilters(
  allFilters: ListingsSearchAllFilters,
): ListingsSearchBarFilters {
  const barFilters: ListingsSearchBarFilters = {
    citySlug: allFilters.citySlug,
    cityName: allFilters.cityName,
    radius: allFilters.radius,
    searchCategories: allFilters.searchCategories,
    maxRent: allFilters.maxRent,
    minSize: allFilters.minSize,
  };

  return barFilters;
}
